// extracted by mini-css-extract-plugin
export default {"createBrainstorm":"CreateBrainstorm_createBrainstorm__UmbjO","message":"CreateBrainstorm_message__g2tgI"};